type Props = {
  bannerImg: string;
  title: string;
};

const TitleBanner = ({ bannerImg, title }: Props) => {
  return (
    <div className="relative mx-auto h-[498px] w-full">
      <img
        src={bannerImg}
        alt="title-banner"
        className="h-full w-full object-cover md:object-cover lg:object-contain"
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <p className="text-center text-[48px] font-extrabold leading-[60px] text-white md:text-[100px] md:leading-[120px]">
          {title}
        </p>
      </div>
    </div>
  );
};

export default TitleBanner;
